module.exports = __webpack_public_path__ + "16cb7b01b16becb41a04d49249a3042a.png";